export default "/assets/1d110181ed0656a1.svg"